module.exports = __webpack_public_path__ + "img/lemon.0c1e239f.png";